import React, { useEffect, useState } from 'react'
import DatePicker from 'react-date-picker'
import { connectAffiliate } from './Affiliate.connect'
import moment from 'moment'

const CommissionReport = ({ actions }) => {
  const [commData, setCommData] = useState([])
  const currentDate = new Date()
  const date7DaysAgo = new Date(currentDate.setDate(currentDate.getDate() - 7))
  const [selectedDateFrom, setSelectedDateFrom] = useState(
    new Date(date7DaysAgo)
  )
  const [selectedDateTo, setSelectedDateTo] = useState(new Date())

  let todayDate = new Date()

  const getMonth = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      month: '2-digit',
    })}`
  }

  const getDate = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      day: '2-digit',
    })}`
  }

  const getMyAffComm = async () => {
    await actions
      .getMyAffComm({
        from_date: selectedDateFrom,
        to_date: selectedDateTo,
      })
      .then((res) => {
        setCommData(res?.data?.data)
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    getMyAffComm()
  }, [])

  // getMyAffComm

  const submit = (e) => {
    e.preventDefault()
    getMyAffComm()
  }

  return (
    <>
      <form className="typeslabel affiliate_filter openbettss affiliate-pl affiliate-report affi-date-filter-form">
        <div className=" account-statement-page__filter-content">
          <div className="account-statement-page__filters-date-input">
            <p>Date from:</p>
            <div>
              <DatePicker
                onChange={setSelectedDateFrom}
                value={selectedDateFrom}
                locale={'en-US'}
                showLeadingZeros={true}
                clearIcon={null}
                calendarIcon={null}
                format={'dd/MM/yyyy'}
                dayPlaceholder={getDate(todayDate)}
                monthPlaceholder={getMonth(todayDate)}
                yearPlaceholder={todayDate.getFullYear()}
              />
            </div>
          </div>
          <div className="account-statement-page__filters-date-input">
            <p>Date to:</p>
            <div>
              <DatePicker
                onChange={setSelectedDateTo}
                value={selectedDateTo}
                locale={'en-US'}
                showLeadingZeros={true}
                clearIcon={null}
                calendarIcon={null}
                format={'dd/MM/yyyy'}
                dayPlaceholder={getDate(todayDate)}
                monthPlaceholder={getMonth(todayDate)}
                yearPlaceholder={todayDate.getFullYear()}
              />
            </div>
          </div>

          <button
            className="account-statement-page__date-search-button"
            onClick={submit}
          >
            <span>Submit</span>
          </button>
        </div>
      </form>
      <div className="nw-affi-user-list-wrapper">
        <div className="table-responsive nw-affi-user-table">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Commission</th>
              </tr>
            </thead>
            <tbody style={{ background: '#fff' }}>
              {commData?.length ? (
                commData.map((item, index) => (
                  <tr key={index} className="user_list_tr">
                    <td className="text-left">
                      {' '}
                      {moment.utc(item?.start_date).format('YYYY-MM-DD')}
                    </td>
                    <td className="text-center">{item?.amount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} className="text-center text-sm p-2">
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default connectAffiliate()(CommissionReport)
